import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for day report lines
const dayReportLinesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/day_report_lines",
  name: "DayReportLinesStoreRefactor",
  objectName: "Dagrapport regel", // Auto-generates CRUD success messages
  enableCache: true, // 5-minute cache for day report lines
  infiniteLoading: false,
});

export const useDayReportLinesStoreRefactor = defineStore(
  "dayReportLinesRefactor",
  {
    ...dayReportLinesBaseStore,

    state: () => ({
      ...dayReportLinesBaseStore.state(),
      icons: {
        administration: { icon: "mdi-book-cross", color: "blue" },
        networking: { icon: "mdi-account-group", color: "pink" },
        fieldwork: { icon: "mdi-account-search", color: "green" },
        cases: { icon: "mdi-account-multiple-outline", color: "orange" },
        other: { icon: "mdi-help-circle", color: "yellow" },
      },
    }),

    getters: {
      ...dayReportLinesBaseStore.getters,

      /**
       * Get all day report lines (maps to state.data for compatibility)
       */
      dayReportLines: (state) => {
        return state.data.sort(
          (a, b) => new Date(a.date_time) - new Date(b.date_time),
        );
      },

      /**
       * Get day report lines filtered by day_report_id
       */
      getLinesByDayReportId: (state) => (dayReportId) => {
        const numericDayReportId = Number(dayReportId);
        return state.data
          .filter((line) => Number(line.day_report_id) === numericDayReportId)
          .sort((a, b) => new Date(a.date_time) - new Date(b.date_time));
      },

      /**
       * Get a specific line by ID (enhanced with baseStore getById)
       */
      getLineById: (state) => (id) => {
        return state.data.find((line) => line.id == id) || null;
      },
    },

    actions: {
      ...dayReportLinesBaseStore.actions,

      /**
       * Fetch day report lines for a specific day report
       * @param {Number} dayReportId - The day report ID
       * @param {Boolean} forceRefresh - Force bypass cache
       */
      async getForDayReport(dayReportId, forceRefresh = false) {
        const customEndpoint = `/api/v1/day_reports/${dayReportId}/day_report_lines`;
        return this.fetchAll({}, forceRefresh, false, customEndpoint);
      },

      // CRUD operations now fully inherited with auto-generated success messages
    },
  },
);
